@import (reference) '../../../constants/spacing.module.less';
@import '~style-sheet-helpers/core.less';

.modal {
  width: 600px;
}

.instructions {
  padding: @space-16;
  display: flex;
  flex-direction: column;
  gap: @space-12;
}

.address-wrapper {
  padding: 0 @space-16 @space-16;
  display: flex;
  flex-direction: column;
  gap: @space-16;
}

.comment-wrapper {
  display: flex;
  flex-direction: column;

  label {
    font-size: 14px !important;
    font-weight: 500 !important;
    align-self: flex-start;
  }

  .comment {
    margin-top: 7px !important;
  }
}

.disabled {
  opacity: 0.6;
  cursor: default;
  box-shadow: none;
  background-color: var(--gray-DFE4E8) !important;
  color: var(--gray-8D9196) !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}

.external-link-icon {
  height: @space-12;
  width: @space-12;
  margin-left: @space-8;
}

.website {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 0;

  label {
    font-size: 14px !important;
    font-weight: 500 !important;
    align-self: flex-start;
  }

  input {
    height: 32px !important;
    margin-top: 7px !important;
  }
}

.received-body {
  padding: @space-16;

  display: flex;
  flex-direction: column;
  gap: @space-12;

  .complete {
    display: flex;
    align-items: center;
    gap: @space-12;
  }

  .bold {
    font-weight: 700;
  }
}

.submit {
  margin-left: @space-16;
}
